// extracted by mini-css-extract-plugin
module.exports = {"root":"Input_root__n1kwg","form":"Input_form__ouB2y","input":"Input_input__2xT0U","submit":"Input_submit__V0Qee","reset":"Input_reset___gP_I","hidden":"Input_hidden__urnm4"};